/* eslint-disable */
import moment from "moment";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
//#end Global Imports

//Local Imports
import Button from "../../../../components/ui/Button";
import { getRequestTime, handleLogin, verifyReCaptcha } from "../../../../services/auth";
import { getErrorMessage, regexForEmailAddress, regexForPassword } from "../../../../utils";
import ErrorField from "../../../../components/ui/ErrorField";
import { Mixpanel } from "../../../../constants/mixpanel";
import AuthBgLayout from "../../../../components/layout/AuthBgLayout";
import TextFieldNew from "../../../../components/ui/TextField/TextFieldNew";
//End Local Imports

interface IProps {
    isUserRegistered: string;
    signInError: string;
    isIncorrectPassword: boolean;
    setIsForgotPassword: React.Dispatch<React.SetStateAction<boolean>>;
    setInorrectPassword: React.Dispatch<React.SetStateAction<boolean>>;
    setIsUserRegistered: React.Dispatch<React.SetStateAction<string>>;
    saveUserData: React.Dispatch<React.SetStateAction<{ email: string; password: string }>>;
    isDisabled: boolean;
    loading: boolean;
    setIsDisabled: React.Dispatch<React.SetStateAction<boolean>>;
    handleClickedLogin: (data: any) => void;
}

type FormInputs = {
    email: string;
    password: string;
};

export const LoginformNew: React.FC<IProps> = ({
    isUserRegistered,
    isIncorrectPassword,
    saveUserData,
    setIsForgotPassword,
    setInorrectPassword,
    setIsUserRegistered,
    isDisabled,
    setIsDisabled,
    handleClickedLogin,
    loading,
    signInError,
}) => {
    const navigate = useNavigate();
    const [email, setEmail] = React.useState<string>("");
    const [password, setPassword] = React.useState<string>("");

    const {
        formState: { errors,isDirty },
        getValues,
        handleSubmit,
        control,
        setError,
    } = useForm<FormInputs>();
    const recaptchaRef = React.useRef<any | null>(null);
    const onSubmit = (data: any) => {
        handleClickedLogin(data);
    };

    const captchaValidate = (token: string | null) => {
        if (token) {
            verifyReCaptcha({ response: token })
                .then((response) => {
                    if (response.data) {
                        setIsDisabled(false);
                    } else {
                        setIsDisabled(true);
                    }
                })
                .catch(() => {
                    setIsDisabled(true);
                });
        }
    };

    useEffect(() => {
        setInorrectPassword(errors.password?.type === "pattern");
    }, [errors.password]);

    return (
        <>
            <AuthBgLayout>
                <div className="flex flex-col items-start w-full">
                    <p className="xl:text-[24px] lg:text-[20px] font-semibold text-[#000] xl:mb-4 lg:mb-2">Log in</p>
                    <form
                        onSubmit={handleSubmit(onSubmit)}
                        className="flex flex-col items-start gap-3 w-full"
                        autoComplete="off"
                    >
                        <div className="w-full">
                            <Controller
                                control={control}
                                name="email"
                                rules={{ required: true, pattern: regexForEmailAddress }}

                                render={({ field: { name, value, onChange } }) => {
                                    return (
                                        <>
                                            <p className="xl:text-base lg:text-sm  font-medium text-[#000] mb-2">Email <span className="text-red-100">*</span></p>
                                            <TextFieldNew
                                                name={name}
                                                type="email"
                                                placeholder="Enter your email"
                                                inputClasses=" flex 
                                                    !h-[40.104px] 
                                                    px-4  
                                                    justify-between 
                                                    items-center 
                                                    self-stretch 
                                                    rounded-[12px] 
                                                    border border-[#B1B1B1]/100 border-[0.5px] 
                                                    bg-[#fff]
                                                    !text-[#000]
                                                    !pt-0
                                                    "
                                                placeholderStyle="text-[#9e9e9e] font-normal text-sm font-inter !top-[0.55rem]"
                                                value={value}
                                                onChange={(v:any) => { setEmail(v.target.value); onChange(v); }}
                                                errorMessage={getErrorMessage(
                                                    errors as Record<string, { type: any }>,
                                                    "email",
                                                    "Email",
                                                )}
                                                error={errors.email}
                                                fullWidth
                                            />
                                        </>
                                    );
                                }}
                            />
                        </div>
                        <div className="flex flex-col w-full">
                            <Controller
                                control={control}
                                name="password"
                                rules={{ required: true, pattern: regexForPassword }}
                                render={({ field: { name, value, onChange } }) => {
                                    return (
                                        <>
                                            <p className="xl:text-base lg:text-sm font-medium text-[#000] mb-2">Password <span className="text-red-100">*</span></p>
                                            <TextFieldNew
                                                name={name}
                                                type="password"
                                                placeholder="Enter your password"
                                                       inputClasses=" flex 
                                                    !h-[40.104px] 
                                                    px-4  
                                                    justify-between 
                                                    items-center 
                                                    self-stretch 
                                                    rounded-[12px] 
                                                    border border-[#B1B1B1]/100 border-[0.5px] 
                                                    bg-[#fff]
                                                    !text-[#000]
                                                    !pt-0
                                                    "
                                                placeholderStyle="text-[#9e9e9e] font-normal text-sm font-inter !top-[0.55rem]"
                                                value={value}
                                                onChange={(v:any) => { setPassword(v.target.value); onChange(v); }}
                                                // error={errors.password || isIncorrectPassword}
                                                error={
                                                    errors.password || isIncorrectPassword || errors.email || isUserRegistered
                                                }
                                                errorMessage={
                                                    (!isIncorrectPassword &&
                                                        getErrorMessage(
                                                            errors as Record<string, { type: any }>,
                                                            "password",
                                                            "Password",
                                                        )) ||
                                                        isUserRegistered !== ""
                                                        ? isUserRegistered
                                                        : getErrorMessage(errors as Record<string, { type: any }>, "email", "Email")
                                                }
                                                // required
                                                fullWidth
                                            />
                                        </>
                                    );
                                }}
                            />
                            {signInError && <ErrorField errorMessage={signInError} />}
                            <div className="flex justify-end w-full !text-sm font-semibold sm:text-base  text-[#0F5BF1] font-inter mt-2">
                                <span className="cursor-pointer" onClick={() => setIsForgotPassword(true)}>
                                    Forgot Password?
                                </span>
                            </div>
                        </div>
                        <div className="w-full xl:mb-4 lg:mb-2">
                            <ReCAPTCHA
                                sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY as string}
                                ref={recaptchaRef}
                                onChange={captchaValidate}
                                theme="light"
                                size="normal"
                            />
                        </div>
                        <div className="flex flex-col items-center gap-1 w-full">
                            <Button
                                bgColor={isDisabled || email === "" || password === "" ? "bg-primary-1050" : "bg-primary-1050"}
                                fontStyle={{
                                    fontFamily: "font-inter",
                                    fontSize: "xl:text-xl lg:text-base",
                                    fontWeight: "font-semibold",
                                    fontColor: "text-white",
                                }}
                                borderStyle={{
                                    borderWidth: "border-none",
                                    borderRadius: "rounded-lg",
                                }}
                                className="w-full xl:h-[46px] lg:h-[36px] disabled:opacity-50 disabled:cursor-not-allowed"
                                isLoading={loading}
                                disabled={(isDisabled && process.env.REACT_APP_ENFORCE_CAPTCHA === "true") || loading || email === "" || password === ""}
                            >
                                Login
                            </Button>
                            <p
                                onClick={() => {
                                    navigate("/auth/sign-up-new");
                                    Mixpanel.track("Signup_button");
                                }}
                                className="text-[#0F5BF1] font-inter xl:text-lg lg:text-base font-normal mt-3 cursor-pointer"
                            >
                                Sign Up
                            </p>
                        </div>
                    </form>
                </div>
            </AuthBgLayout>
        </>
    );
};
